import React from "react";
import { Container, ModalWrapper, CloseButton } from "./styles/modal";

export default function Modal({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

Modal.ModalWrapper = function ModalModalWrapper({ children, ...props }) {
  return <ModalWrapper {...props}>{children}</ModalWrapper>;
};

Modal.CloseButton = function ModalCloseButton({
  children,
  ...props
}) {
  return <CloseButton {...props}>{children}</CloseButton>;
};
